import { createZodDto } from 'nestjs-zod/dto';
import { z } from 'zod';
import { paginatedResponse } from '#web-service-api/common';
import { GuestLinkBaseResponseSchema } from './guest-link-base-response.dto';
export const GuestLinkResponseSchema = GuestLinkBaseResponseSchema.extend({
    emailsCount: z.number(),
});
export class GuestLinkSimpleResponseDto extends createZodDto(GuestLinkResponseSchema) {
}
const guestLinkListResponseSchema = paginatedResponse(GuestLinkResponseSchema);
export class GuestLinkListResponseDto extends createZodDto(guestLinkListResponseSchema) {
}
